export const BRAND_TOOL = {
  profile: 'read_brand_profile',
  page: 'fetch_page',
  propose: 'propose_voice',
  update: 'update_voice',
  show: 'show_voice'
} as const

export const VOICE_CARD = 'voice'

// Only a member who may edit the brand sets its voice.
export const maySetVoice = (scope: { readonly rights: readonly string[] }) => scope.rights.includes('brand.write')
